import { render, staticRenderFns } from "./MeasureForm.vue?vue&type=template&id=1abc8c13&"
import script from "./MeasureForm.vue?vue&type=script&lang=js&"
export * from "./MeasureForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports